import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoSchedule from "../../components/BookDemo/thankyouPageDigi/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/thankyouPageDigi/SuccessMessage";

import { initGA2, initPixel } from "../../helpers/CampaignEvents";


const ThankYouPageDigi = () => {
  const { component } = useParams();

  useEffect(() => {

    initPixel()
    initGA2()
  }, [])
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessage />
          ) :(
            <DemoSchedule />

          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPageDigi;
